<template>
    <div>
        <!-- zIndexEdit降低优先级，后期可增加可调优先级 -->
        <modalreal v-if="show" :zIndexEdit='true'>
            <!-- 标题插槽 -->
            <div slot="title">111</div>
            <!-- 搜索框插槽 -->
            <div slot="serch">1111</div>
            <!-- 内容区插槽 -->
            <div slot="contner">111</div>
            <!-- 底部区插槽 -->
            <div slot="foter">
                <el-button
                    type=""
                    size="mini"
                    icon="el-icon-close"
                    round
                    @click="show=false"
        >{{$t('message.关闭')}}</el-button
      >
            </div>
        </modalreal>
    </div>
</template>
<script>
// 弹出框组件封装
import modalreal from '@/components/modalCom/modalreal'
export default {
    components:{
        modalreal
    },
    data(){
        return{
            show:true
        }
    }
}
</script>
<style  scoped>

</style>


// WEBPACK FOOTER //
// src/pages/settings/test.vue